import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Youtube, Mail, MapPin, Phone } from "lucide-react";
import { TID } from "@/lib/testIds";

const COLS = [
  {
    title: "Secciones",
    links: [
      { to: "/categoria/ultimas-noticias", label: "Últimas noticias" },
      { to: "/categoria/politica", label: "Política" },
      { to: "/categoria/economia", label: "Economía" },
      { to: "/categoria/policiales", label: "Policiales" },
      { to: "/categoria/deportes", label: "Deportes" },
    ],
  },
  {
    title: "Ciudades",
    links: [
      { to: "/categoria/ushuaia", label: "Ushuaia" },
      { to: "/categoria/rio-grande", label: "Río Grande" },
      { to: "/categoria/tolhuin", label: "Tolhuin" },
      { to: "/categoria/provincial", label: "Provincial" },
    ],
  },
  {
    title: "Institucional",
    links: [
      { to: "/quienes-somos", label: "Quiénes somos" },
      { to: "/contacto", label: "Contacto" },
      { to: "/politicas-de-privacidad", label: "Políticas de privacidad" },
      { to: "/categoria/opinion", label: "Opinión" },
      { to: "/categoria/videos", label: "Videos" },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid={TID.footer} className="mt-16 bg-nightblue text-white">
      <div className="container-wide py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="font-serif text-3xl font-black leading-none">
            Sur<span className="text-watergreen">Primicia</span>
          </div>
          <p className="mt-4 text-sm text-white/70 leading-relaxed max-w-xs">
            Portal digital independiente con foco en Tierra del Fuego, Antártida e Islas del Atlántico Sur.
          </p>
          <div className="mt-6 flex items-center gap-4">
            <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-watergreen transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href="https://x.com/" target="_blank" rel="noopener noreferrer" aria-label="X" className="hover:text-watergreen transition-colors"><Twitter className="w-4 h-4" /></a>
            <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-watergreen transition-colors"><Instagram className="w-4 h-4" /></a>
            <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="hover:text-watergreen transition-colors"><Youtube className="w-4 h-4" /></a>
          </div>
        </div>

        {COLS.map((col) => (
          <div key={col.title}>
            <div className="text-xs uppercase tracking-[0.18em] text-watergreen font-semibold">{col.title}</div>
            <ul className="mt-4 space-y-2.5">
              {col.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/80 hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-white/10">
        <div className="container-wide py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/60">
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <span className="inline-flex items-center gap-1.5"><Mail className="w-3.5 h-3.5" /> redaccion@surprimicia.com.ar</span>
            <span className="inline-flex items-center gap-1.5"><Phone className="w-3.5 h-3.5" /> +54 2901 000-000</span>
          </div>
          <div className="uppercase tracking-[0.14em]" data-testid="footer-copyright">
            © {year} Sur Primicia ·{" "}
            <Link to="/politicas-de-privacidad" data-testid="footer-privacy-link" className="hover:text-white">
              Políticas de privacidad
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
